module.exports = __webpack_public_path__ + "img/aefee7175194f79342359bac25e1e424.8e941980.jpg";